import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '~/hooks/useAuth';

export const ProtectedRoute = () => {
  const { user, loading, isAdmin } = useAuth();

  console.log('[ProtectedRoute] render', { loading, hasUser: !!user, isAdmin, email: user?.email });

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    console.log('[ProtectedRoute] no user or not admin, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  console.log('[ProtectedRoute] authenticated, rendering outlet');
  return <Outlet />;
};
